// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-PatientPage-Notes-__note__container--vmasH","note":"src-components-PatientPage-Notes-__note__note--Gyk0q","body":"src-components-PatientPage-Notes-__note__body--2iM-3","sideHover":"src-components-PatientPage-Notes-__note__sideHover--2shye","editButton":"src-components-PatientPage-Notes-__note__editButton--1LcmQ","timestamp":"src-components-PatientPage-Notes-__note__timestamp--13-Xj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientPage/Notes/note.css
// module id = 1985
// module chunks = 0